import * as _ from 'lodash';
import { IBaseTable, ITableSection, ITableSettings } from 'src/app/interfaces/calibration-set-table.interface';
import {
    IFieldSettings,
    IFieldsValidatorsMap,
    ITableFieldDictionary
} from 'src/app/interfaces/field-settings.interface';
import { ITableFieldsConfiguration } from 'src/app/interfaces/tables/table-fields-configuration.interface';

export class TableSettings implements ITableSettings {
    hasSections: boolean;
    sections: Array<ITableSection> = [];
    fieldValidation: IFieldsValidatorsMap = {};
    dictionary?: ITableFieldDictionary;
    fields: IFieldSettings[] = [];

    constructor(settings: ITableFieldsConfiguration, dictionary?: ITableFieldDictionary, hasSections?: boolean) {
        this.dictionary = dictionary || {};
        this.hasSections = hasSections;
        this.fields = settings.fieldsFactory();
        this.initSections(settings);
        this.initFieldValidation(settings);
    }

    private initSections(settings: ITableFieldsConfiguration) {
        if (!settings) {
            return;
        }
        const sections = settings.sections;

        if (this.hasSections && _.get(sections, 'length', 0)) {
            this.sections = sections.map(label => {
                return { label, fields: [], requiredFields: [] };
            });
        } else {
            this.sections.push({ label: '', fields: [], requiredFields: [] });
        }

        this.fields.forEach(field => {
            const sectionId = field.section || 0;
            field.label = _.get(this, `dictionary.${field.name}.label`, '');
            this.sections[sectionId].fields.push(field);
            if (field.isRequired || field.isRelatedToRequired) {
                this.sections[sectionId].requiredFields.push(field);
            }
        });
    }

    private initFieldValidation(settings: ITableFieldsConfiguration) {
        if (!settings) {
            return;
        }
        const fields = this.fields;

        if (!_.get(fields, 'length', 0)) {
            return;
        }
        fields.forEach(field => {
            this.fieldValidation[field.name] = field;
        });
    }

    detectGlobalChanges(table: IBaseTable, setDefaultFlags: boolean = false) {
        if (!table) {
            return;
        }
        this.fields.forEach(field => {
            field.detectGlobalChanges(table, setDefaultFlags);
        });
    }
}
